export const COOKIE_BANNER_I18N = {
    EN_US: 'en_US',
    DA_DK: 'da_DK',
    DE_DE: 'de_DE',
    ES_ES: 'es_ES',
    NB_NO: 'nb_NO',
    NL_NL: 'nl_NL',
};
